import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

function isSuccess(res) {
  return res && (res.code === 0 || res.code === 200 || res.code === '0' || res.code === '200' || res.success || res.msg === 'success')
}

function resolveResponse(response, fallbackMessage) {
  const res = response.data
  if (isSuccess(res) || Array.isArray(res) || Array.isArray(res.data) || Array.isArray(res.records)) {
    return res
  }
  throw new Error((res && res.msg) || fallbackMessage)
}

function withCommunity(payload) {
  return {
    ...payload,
    communityId: payload && payload.communityId ? payload.communityId : getCommunityId()
  }
}

// 查询凭证列表
export function listVouchers(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/voucher.listVoucher',
      method: 'get',
      params: withCommunity(params || {})
    }).then(response => {
      resolve(resolveResponse(response, '获取凭证列表失败'))
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询凭证详情
export function getVoucherDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/voucher.getVoucherDetail',
      method: 'get',
      params: withCommunity(params || {})
    }).then(response => {
      resolve(resolveResponse(response, '获取凭证详情失败'))
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增凭证
export function saveVoucher(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/voucher.saveVoucher',
      method: 'post',
      data: withCommunity(data || {})
    }).then(response => {
      resolve(resolveResponse(response, '新增凭证失败'))
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新凭证
export function updateVoucher(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/voucher.updateVoucher',
      method: 'post',
      data: withCommunity(data || {})
    }).then(response => {
      resolve(resolveResponse(response, '更新凭证失败'))
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除凭证
export function deleteVoucher(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/voucher.deleteVoucher',
      method: 'post',
      data: withCommunity(data || {})
    }).then(response => {
      resolve(resolveResponse(response, '删除凭证失败'))
    }).catch(error => {
      reject(error)
    })
  })
}

// 上传附件
export function uploadVoucherAttachment(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/callComponent/upload/uploadFile/uploadImage',
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data
    }).then(response => {
      const res = response.data
      // 兼容标准 code/msg/data 结构，也兼容直接返回 url/fileId 的上传接口
      if (res && (res.url || res.fileId || res.fileUrl || res.path)) {
        resolve(res)
      } else if (isSuccess(res)) {
        resolve(res.data || res)
      } else {
        reject(new Error((res && res.msg) || '附件上传失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询凭证变更记录
export function listVoucherChangeRecord(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/voucher.listVoucherChangeRecord',
      method: 'get',
      params: withCommunity(params || {})
    }).then(response => {
      resolve(resolveResponse(response, '获取凭证变更记录失败'))
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取小区公账账户信息
export function getCommunityPublicAccount(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/voucher.getCommunityPublicAccount',
      method: 'post',
      data: withCommunity(params || {})
    }).then(response => {
      resolve(resolveResponse(response, '获取小区公账账户信息失败'))
    }).catch(error => {
      reject(error)
    })
  })
}
